/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents Approval status attributes
 * <\/code><\/pre>
 **/
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["APPROVAL_COMPLETED"] = "APPROVAL_COMPLETED";
    ApprovalStatus["APPROVAL_CREATED"] = "APPROVAL_CREATED";
    ApprovalStatus["APPROVAL_PENDING"] = "APPROVAL_PENDING";
    ApprovalStatus["APPROVAL_CREATION_IN_PROGRESS"] = "APPROVAL_CREATION_IN_PROGRESS";
    ApprovalStatus["APPROVAL_IN_PROGRESS"] = "APPROVAL_IN_PROGRESS";
})(ApprovalStatus || (ApprovalStatus = {}));
